import PopupComponents from './popup.vue';

const popup = {
    install:function(Vue) {
        Vue.component('defalutPopup', PopupComponents)
    }
}

export default popup;


// WEBPACK FOOTER //
// ./src/components/public/defalut-popup/index.js